export default __webpack_public_path__ + "static/media/checkPilotSmile.3a72704c.png";